import { CortesForm } from '@/features/factory/subfactories/CortesForm'

/** Sub-route /factory/cortes — wraps the Cortes (podcast → Shorts) form. */
export function CortesPage() {
  return <CortesForm />
}
